import { useIsNative } from '~/context/common/DeviceContext';
import { useConfiguration } from '~/context/common/StaticContext';

export default function useDisableModalHistory(): boolean {
  const isNative = useIsNative();
  const { disableModalHistory } = useConfiguration();

  return disableModalHistory || isNative;
}
